"use strict";var p=Object.defineProperty;var f=Object.getOwnPropertyDescriptor;var h=Object.getOwnPropertyNames;var g=Object.prototype.hasOwnProperty;var $=(e,r)=>{for(var i in r)p(e,i,{get:r[i],enumerable:!0})},F=(e,r,i,t)=>{if(r&&typeof r=="object"||typeof r=="function")for(let a of h(r))!g.call(e,a)&&a!==i&&p(e,a,{get:()=>r[a],enumerable:!(t=f(r,a))||t.enumerable});return e};var x=e=>F(p({},"__esModule",{value:!0}),e);var I={};$(I,{AtomFeed:()=>d,Feed:()=>o,JsonFeed:()=>s,RssFeed:()=>l,default:()=>b});module.exports=x(I);var o=class{constructor(r,i){this.metadata=r,this.items=i}addItem(r){this.items.push(r)}getItems(){return this.items}getMetadata(){return this.metadata}};function n(e){return e.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}function u(e,r){let i=r.map(t=>`
      <entry>
        <title>${n(t.title)}</title>
        <link href="${t.url}" />
        <id>${t.id}</id>
        <updated>${new Date(t.updated||t.published).toISOString()}</updated>
        <published>${new Date(t.published).toISOString()}</published>
        ${t.author?`<author><name>${n(t.author)}</name></author>`:""}
        ${t.contentHtml?`<content type="html"><![CDATA[${t.contentHtml}]]></content>`:""}
        ${t.description?`<summary><![CDATA[${t.description}]]></summary>`:""}
      </entry>
    `).join(`
`);return`<?xml version="1.0" encoding="utf-8"?>
  <feed xmlns="http://www.w3.org/2005/Atom">
    <title>${n(e.title)}</title>
    <subtitle>${n(e.description)}</subtitle>
    <link href="${e.url}" />
    <id>${e.id}</id>
    <updated>${new Date(e.updated||new Date().toISOString()).toISOString()}</updated>
    ${e.author?`<author><name>${n(e.author)}</name></author>`:""}
    ${i}
  </feed>`.trim()}var d=class extends o{render(){return u(this.metadata,this.items)}};function m(e,r){let i={version:"https://jsonfeed.org/version/1.1",title:e.title,home_page_url:e.url,feed_url:e.id,description:e.description,language:e.language,icon:e.logo,favicon:e.favicon,author:e.author?{name:e.author}:void 0,items:r.map(t=>({id:t.id,url:t.url,title:t.title,content_html:t.contentHtml||t.description,summary:t.description,date_published:t.published,date_modified:t.updated,author:t.author?{name:t.author}:void 0,image:t.image}))};return JSON.stringify(i,null,2)}var s=class extends o{render(){return m(this.metadata,this.items)}};function c(e,r){let i=r.map(t=>`
      <item>
        <title>${n(t.title)}</title>
        <link>${t.url}</link>
        <guid>${t.id}</guid>
        <pubDate>${new Date(t.published).toUTCString()}</pubDate>
        ${t.description?`<description><![CDATA[${t.description}]]></description>`:""}
      </item>
    `).join(`
`);return`<?xml version="1.0" encoding="UTF-8"?>
  <rss version="2.0">
    <channel>
      <title>${n(e.title)}</title>
      <link>${e.url}</link>
      <description>${n(e.description)}</description>
      ${e.updated?`<lastBuildDate>${new Date(e.updated).toUTCString()}</lastBuildDate>`:""}
      ${i}
    </channel>
  </rss>`.trim()}var l=class extends o{render(){return c(this.metadata,this.items)}};var b={Feed:o,RssFeed:l,AtomFeed:d,JsonFeed:s};0&&(module.exports={AtomFeed,Feed,JsonFeed,RssFeed});
//# sourceMappingURL=index.js.map